import { render, staticRenderFns } from "./single_mobile_market.vue?vue&type=template&id=3b60f266&"
import script from "./single_mobile_market.vue?vue&type=script&lang=js&"
export * from "./single_mobile_market.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports